/* eslint-disable class-methods-use-this */
import {
    post,
    get,
    put,
    _delete,
  } from '@/lin/plugins/axios'
  
  const _baseUri = 'plugin/xy/home/'
  
  class Home {
    // constructor() {}
    async addBanner(info) {
      const res = await post(`${_baseUri}banner/`, info)
      return res
    }
  
    async getBanner(id) {
      const res = await get(`${_baseUri}banner/${id}`)
      return res
    }
  
    async editBanner(id, info) {
      const res = await put(`${_baseUri}banner/${id}`, info)
      return res
    }
  
    async delectBanner(id) {
      const res = await _delete(`${_baseUri}banner/${id}`)
      return res
    }
  
    async getBanners(pageInfo) {
      const res = await get(`${_baseUri}banner/`, pageInfo)
      return res
    }
  }
  
  export default new Home()
  